/* Body Mist BOGO — injects a "Buy 1 Get 1 Free, build your box" button on the
   PDP (hides native Add to Cart), opens an overlay where the viewed spray is the
   locked first bottle and the shopper picks one free second. The product grid is
   rendered server-side from the live collection, so only ACTIVE sprays appear. */
(function () {
  'use strict';

  var cfgEl = document.getElementById('bmm-config');
  var root = document.getElementById('bmm-root');
  if (!cfgEl || !root) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG.eligible) return;

  var MAX_TOTAL = 2; // one BOGO pair only: locked first bottle + 1 free
  var rootId = String(CFG.rootId || '');

  var overlay = root.querySelector('[data-bmm-overlay]');
  var grid = root.querySelector('[data-bmm-grid]');
  var searchInput = root.querySelector('[data-bmm-search]');
  var emptyEl = root.querySelector('[data-bmm-empty]');
  var tallyEl = root.querySelector('[data-bmm-tally]');
  var fillEl = root.querySelector('[data-bmm-fill]');
  var nudgeEl = root.querySelector('[data-bmm-nudge]');
  var doneBtn = root.querySelector('[data-bmm-done]');
  var triggerBtn = null;

  var cards = [];      // [{id, title, el}]
  var qty = {};        // variantId -> 0/1
  var built = false;

  function total() { var t = 0; Object.keys(qty).forEach(function (k) { t += qty[k]; }); return t; }

  function openCartDrawer() {
    if (window.EliteCart && typeof window.EliteCart.openDrawerWithDataRefresh === 'function') {
      window.EliteCart.openDrawerWithDataRefresh();
    } else {
      var link = document.querySelector('a.header__icon--cart, a[href$="/cart"]');
      if (link) link.click(); else window.location.href = '/cart';
    }
  }

  function openOverlay() { build(); overlay.hidden = false; document.documentElement.classList.add('bmm-open'); }
  function closeOverlay() { overlay.hidden = true; document.documentElement.classList.remove('bmm-open'); }

  /* ---- read the server-rendered cards once ------------------------------ */
  function build() {
    if (built) { refresh(); return; }
    built = true;
    cards = [].slice.call(grid.querySelectorAll('.bmm__card')).map(function (el) {
      return { id: el.getAttribute('data-variant-id'), title: (el.getAttribute('data-title') || ''), el: el };
    });
    // the viewed spray is the locked first bottle; float its card to the front
    if (rootId) {
      var rootCard = cards.filter(function (c) { return c.id === rootId; })[0];
      if (rootCard) {
        qty[rootId] = qty[rootId] || 1;
        grid.insertBefore(rootCard.el, grid.firstChild);
      }
    }
    refresh();
  }

  function applyFilter() {
    var q = (searchInput ? searchInput.value : '').trim().toLowerCase();
    var shown = 0;
    cards.forEach(function (c) {
      var match = !q || c.title.indexOf(q) > -1;
      c.el.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    if (emptyEl) emptyEl.hidden = shown > 0;
  }

  function updateCards() {
    var capped = total() >= MAX_TOTAL;
    cards.forEach(function (c) {
      var n = qty[c.id] || 0;
      var isRoot = c.id === rootId;
      var ctrl = c.el.querySelector('[data-bmm-ctrl]');
      if (!ctrl) return;
      c.el.classList.toggle('is-selected', n > 0 && !isRoot);
      c.el.classList.toggle('is-root', isRoot);
      if (isRoot) {
        if (n >= 2) {
          ctrl.innerHTML = '<button type="button" class="bmm__add is-added" data-bmm-root-dec>✓ 2 in box &nbsp;&minus;</button>';
        } else if (total() < MAX_TOTAL) {
          ctrl.innerHTML = '<button type="button" class="bmm__add is-locked" disabled>✓ In box</button>' +
            '<button type="button" class="bmm__add bmm__add--ghost" data-bmm-root-inc>+ Add another</button>';
        } else {
          ctrl.innerHTML = '<button type="button" class="bmm__add is-locked" disabled>✓ In box</button>';
        }
      } else if (n > 0) {
        ctrl.innerHTML = '<button type="button" class="bmm__add is-added" data-bmm-toggle>Added ✓</button>';
      } else {
        ctrl.innerHTML = '<button type="button" class="bmm__add' + (capped ? ' is-disabled' : '') + '" data-bmm-toggle' + (capped ? ' disabled' : '') + '>Add</button>';
      }
    });
  }

  function updateProgress() {
    var t = total();
    var free = Math.floor(t / 2);
    if (tallyEl) tallyEl.textContent = t + ' bottle' + (t === 1 ? '' : 's') + ' · ' + free + ' free';
    if (fillEl) fillEl.style.width = (t === 0 ? 0 : (t >= 2 ? 100 : 50)) + '%';
    if (nudgeEl) nudgeEl.textContent = t < 2 ? 'Add 1 more — it’s FREE!' : 'Your free bottle is unlocked!';
    if (doneBtn) {
      if (t < 2) { doneBtn.disabled = true; doneBtn.textContent = 'Pick your free 2nd bottle'; }
      else { doneBtn.disabled = false; doneBtn.textContent = 'Add your Body Mists to Cart'; }
    }
  }

  function refresh() { applyFilter(); updateCards(); updateProgress(); }

  /* ---- interactions ----------------------------------------------------- */
  grid.addEventListener('click', function (e) {
    var card = e.target.closest('.bmm__card');
    if (!card) return;
    if (e.target.closest('[data-bmm-root-inc]')) { if (total() < MAX_TOTAL) { qty[rootId] = (qty[rootId] || 1) + 1; refresh(); } return; }
    if (e.target.closest('[data-bmm-root-dec]')) { qty[rootId] = Math.max(1, (qty[rootId] || 1) - 1); refresh(); return; }
    if (!e.target.closest('[data-bmm-toggle]')) return;
    var id = card.getAttribute('data-variant-id');
    if (id === rootId) return;
    if (qty[id]) { delete qty[id]; }
    else { if (total() >= MAX_TOTAL) return; qty[id] = 1; }
    refresh();
  });

  if (searchInput) { var st; searchInput.addEventListener('input', function () { clearTimeout(st); st = setTimeout(applyFilter, 110); }); }

  doneBtn.addEventListener('click', function () {
    var items = Object.keys(qty).map(function (id) { return { id: parseInt(id, 10), quantity: qty[id] }; });
    if (items.length < 2) return;
    doneBtn.disabled = true;
    doneBtn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error((res.body && res.body.description) || 'Could not add to cart'); }
        openCartDrawer(); closeOverlay(); doneBtn.textContent = 'Add your Body Mists to Cart'; doneBtn.disabled = false;
      })
      .catch(function (err) { doneBtn.textContent = 'Try again'; doneBtn.disabled = false; if (nudgeEl) nudgeEl.textContent = (err && err.message) || 'Could not add to cart'; });
  });

  root.querySelectorAll('[data-bmm-close]').forEach(function (b) { b.addEventListener('click', closeOverlay); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeOverlay(); });

  function onTriggerClick() { openOverlay(); }

  /* ---- PDP button injection (mirror of bogo-offer) ---------------------- */
  function injectButton() {
    var form = document.querySelector('form[action$="/cart/add"]:not([id^="product-form-installment"])');
    if (!form || form.querySelector('[data-bmm-trigger]')) return true;
    var submit = form.querySelector('button[name="add"], [data-btn-addToCart], button[type="submit"]');
    if (!submit) return false;
    var wrap = document.createElement('div'); wrap.className = 'bmm__cta';
    wrap.innerHTML = '<button type="button" class="bmm__btn--bogo" data-bmm-trigger aria-label="Buy one get one free, build your box">' +
      '<span class="bmm__shine"></span>' +
      '<span class="bmm__bogo-top"><span class="bmm__gift">🎁</span><span class="bmm__bogo-main">BUY 1 GET 1 FREE</span></span>' +
      '<span class="bmm__bogo-cta">Tap to build your box <span class="bmm__arrow">→</span></span></button>';
    submit.parentNode.insertBefore(wrap, submit);
    submit.style.setProperty('display', 'none', 'important');
    triggerBtn = wrap.querySelector('[data-bmm-trigger]');
    triggerBtn.addEventListener('click', onTriggerClick);
    return true;
  }

  if (!injectButton()) {
    var tries = 0, iv = setInterval(function () { if (injectButton() || ++tries > 40) clearInterval(iv); }, 250);
  }
})();
